var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediumBattery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1087 26.3574H17.8973C17.1602 26.3242 16.5337 26.8828 16.4922 27.6113V31.4804C16.5357 32.207 17.1622 32.7636 17.8973 32.7304H31.1087C31.8418 32.7636 32.4683 32.205 32.5079 31.4804V27.6113C32.4703 26.8828 31.8438 26.3242 31.1087 26.3574Z",
    fill: "#E2C508"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1087 34.9314H17.8973C17.1602 34.8982 16.5337 35.4568 16.4922 36.1853V40.0525C16.5357 40.781 17.1622 41.3376 17.8973 41.3025H31.1087C31.8418 41.3377 32.4683 40.779 32.5079 40.0525V36.1853C32.4703 35.4587 31.8438 34.8982 31.1087 34.9314Z",
    fill: "#E2C508"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5534 6.8789H28.7708V5.1406C28.7708 4.5117 28.255 4.00195 27.6186 4H21.2925C20.6561 4.00195 20.1423 4.51365 20.1423 5.1406V6.87695L17.4506 6.8789C15.8221 6.8789 14.5 8.1836 14.5 9.7949V41.0879C14.504 42.6973 15.8241 44 17.4506 44H31.5534C33.1798 43.998 34.498 42.6953 34.5 41.0879V9.7949C34.5 8.1855 33.1818 6.88085 31.5534 6.8789ZM33.5138 41.0899V41.0879C33.5119 42.1582 32.6344 43.0235 31.5534 43.0254H17.4506C16.3676 43.0254 15.4881 42.1582 15.4862 41.0879V9.79495C15.4881 8.7227 16.3676 7.8555 17.4506 7.85355H31.5534C32.6364 7.85745 33.5119 8.72465 33.5138 9.79495V41.0899Z",
    fill: "#E2C508"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumBattery);
export default __webpack_public_path__ + "static/media/mediumBattery.7c63e567bf7096cf2d9cc2f7904fc78c.svg";
export { ForwardRef as ReactComponent };